module.exports = __webpack_public_path__ + "assets/img/2021active-bg.ace9acca.png";